export interface DraftPromoteFieldError {
  draftId: number | null;
  fields: string[];
}

export interface DraftErrorInfo {
  code?: string;
  message?: string;
  fields: DraftPromoteFieldError[];
}

export const parsePromoteErrors = (
  message?: string,
): DraftPromoteFieldError[] => {
  if (!message) return [];
  const marker = "incomplete:";
  const idx = message.indexOf(marker);
  const body = idx >= 0 ? message.slice(idx + marker.length) : message;
  return body
    .split(";")
    .map((seg) => seg.trim())
    .filter(Boolean)
    .map((seg) => {
      const m = seg.match(/Draft\s+(\d+)\s*:?\s*(.*)/i);
      if (!m) return { draftId: null, fields: [seg] };
      const draftId = Number(m[1]);
      const fields = (m[2] || "")
        .split(",")
        .map((f) => f.replace(/must not be null/gi, "").trim())
        .filter(Boolean);
      return {
        draftId: Number.isFinite(draftId) ? draftId : null,
        fields,
      };
    });
};

export const extractPromoteError = (err: any): DraftErrorInfo => {
  const data = err?.response?.data ?? {};
  const message: string | undefined = data.message ?? err?.message;
  return {
    code: data.code,
    message,
    fields: parsePromoteErrors(message),
  };
};
